"use strict";

var _classCallCheck = require("/root/workspace/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/root/workspace/node_modules/@babel/runtime/helpers/createClass");

var _inherits = require("/root/workspace/node_modules/@babel/runtime/helpers/inherits");

var _possibleConstructorReturn = require("/root/workspace/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/root/workspace/node_modules/@babel/runtime/helpers/getPrototypeOf");

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var prosemirror_state_1 = require("prosemirror-state");

var Extension_1 = __importDefault(require("../lib/Extension"));

var Keys = /*#__PURE__*/function (_Extension_1$default) {
  _inherits(Keys, _Extension_1$default);

  var _super = _createSuper(Keys);

  function Keys() {
    _classCallCheck(this, Keys);

    return _super.apply(this, arguments);
  }

  _createClass(Keys, [{
    key: "name",
    get: function get() {
      return "keys";
    }
  }, {
    key: "plugins",
    get: function get() {
      var _this = this;

      return [new prosemirror_state_1.Plugin({
        props: {
          handleKeyDown: function handleKeyDown(view, event) {
            if (view.state.selection instanceof prosemirror_state_1.AllSelection) {
              if (event.key === "ArrowUp") {
                var selection = prosemirror_state_1.Selection.atStart(view.state.doc);
                view.dispatch(view.state.tr.setSelection(selection));
                return true;
              }

              if (event.key === "ArrowDown") {
                var _selection = prosemirror_state_1.Selection.atEnd(view.state.doc);

                view.dispatch(view.state.tr.setSelection(_selection));
                return true;
              }
            }

            if (!event.metaKey) return false;

            if (event.key === "s") {
              event.preventDefault();

              _this.options.onSave();

              return true;
            }

            if (event.key === "Enter") {
              event.preventDefault();

              _this.options.onSaveAndExit();

              return true;
            }

            if (event.key === "Escape") {
              event.preventDefault();

              _this.options.onCancel();

              return true;
            }

            return false;
          }
        }
      })];
    }
  }]);

  return Keys;
}(Extension_1.default);

exports.default = Keys;